/**
 * @file 建议
 * @author svon.me@gmail.com
 * @description 浏览器版本不符合最低要求的用户，建议更换浏览器
 */

import * as _ from "lodash-es";
import { userAgent, minVersion } from "./index";

const html = function() {
  const option = {
    imports: {
      minVersion,
      ua: userAgent()
    }
  };
  const template = _.template(`<div class="h-full text-[#333333] bg-white bg-opacity-90 p-8 animate__animated animate__fadeIn">
    <h2 class="text-2xl">当前使用的浏览器内核版本过低 :(</h2>
    <div class="text-sm pt-5">
      <p class="mb-2.5 last:mb-0">
        <span>当前版本: </span>
        <span><%- ua.getBrowserName() %></span>
        <span><%- ua.getBrowserVersion() %></span>
      </p>
      <p class="mb-2.5 last:mb-0">
        <span>最低版本要求: </span>
        <% _.each(minVersion, function(version, name) { %>
          <span class="inline-block after:content-['、'] last:after:content-['。']"><%- name %> <%- version %>+</span>
        <% }) %>
      </p>
      <p class="mb-2.5 last:mb-0">
        <span>请升级浏览器版本，或更换现代浏览器，如果你使用的是双核浏览器,请切换到极速/高速模式。</span>
        <span>推荐使用 <a class="text-sky-500" href="https://www.microsoft.com/zh-cn/edge" target="_blank">Microsoft Edge</a>。</span>
      </p>
    </div>
  </div>`, option);
  return template({});
}

const recommend = function() {
  const text = html();
  $("#app").html(text);
}

export default recommend;